import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { StepperOrientation } from '@angular/material/stepper';
import { ActivatedRoute } from '@angular/router';
import { NavigationService } from 'src/app/services/navigation.service';
import { CustomerRequestDataService } from 'src/app/services/customer-request-data.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { UserdataService } from 'src/app/services/userdata.service';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { forkJoin } from 'rxjs';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatSelectChange } from '@angular/material/select';
import { RegisterDataService } from 'src/app/services/register-data.service';
import { NotificationService } from 'src/app/services/notification-service';
import { DatePipe } from '@angular/common';
import { MatCheckboxChange } from '@angular/material/checkbox';
import Swal from 'sweetalert2';

interface SaIdDetails {
  dateOfBirth: Date;
  gender: 'male' | 'female';
  citizenship: 'citizen' | 'permanent_resident';
}

interface SaIdValidationResult {
  valid: boolean;
  error?: string;
  details?: SaIdDetails;
}

function validateSaId(id: string): SaIdValidationResult {
  if (!/^\d{13}$/.test(id)) {
    return { valid: false, error: 'ID must be exactly 13 digits' };
  }

  const yy = parseInt(id.slice(0, 2));
  const mm = parseInt(id.slice(2, 4));
  const dd = parseInt(id.slice(4, 6));
  const year = yy <= new Date().getFullYear() % 100 ? 2000 + yy : 1900 + yy;

  const dob = new Date(year, mm - 1, dd);
  const dobValid =
    dob.getFullYear() === year &&
    dob.getMonth() === mm - 1 &&
    dob.getDate() === dd;

  if (!dobValid) {
    return { valid: false, error: `Invalid date of birth: ${id.slice(0, 6)}` };
  }

  const digits = id.split('').map(Number);
  let sum = 0;
  for (let i = 0; i < 12; i++) {
    if (i % 2 === 0) {
      sum += digits[i];
    } else {
      const doubled = digits[i] * 2;
      sum += doubled > 9 ? doubled - 9 : doubled;
    }
  }

  const expectedCheck = (10 - (sum % 10)) % 10;
  if (expectedCheck !== digits[12]) {
    return {
      valid: false,
      error: `Luhn checksum failed: expected ${expectedCheck}, got ${digits[12]}`,
    };
  }

  return {
    valid: true,
    details: {
      dateOfBirth: dob,
      gender: parseInt(id.slice(6, 10)) >= 5000 ? 'male' : 'female',
      citizenship: id[10] === '0' ? 'citizen' : 'permanent_resident',
    },
  };
}

function saIdValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value ?? '';

  if (!value) {
    return null;
  }

  if (value.length !== 13) {
    return null;
  }
  const result = validateSaId(control.value ?? '');
  return result.valid ? null : { saId: result.error };
}

@Component({
  selector: 'app-add-login',
  templateUrl: './add-login.component.html',
  styleUrls: ['./add-login.component.scss']
})
export class AddLoginFormComponent implements OnInit {
  requestFormGroup: FormGroup;
  paramsid: any;
  title: any;
  roleList: any = [];
  resellerList: any = [];
  maxDate: any;
  minDate: any;
  @ViewChild('dateOfBirth') dateOfBirthPicker: MatDatepicker<Date>;
  filterRoleList: any = [];
  showReseller: boolean;
  showResellerCustomer: boolean;
  filterResellerList: any = [];
  userDetails: any = {};
  isReachChecked: boolean = false;
  isReachCheckBoxShow: boolean = true;
  roleListReach: any;
  isUserAddedToReach: boolean = false;
  showCompanyRegistrationNumber: boolean = false;

  constructor(private navigate: NavigationService,
    private fb: FormBuilder,
    private loader: LoaderService,
    public dialog: MatDialog,
    public CustomerRequestDataService: CustomerRequestDataService,
    public UserdataService: UserdataService,
    private activateroute: ActivatedRoute,
    private lookupdataservice: LookupDataServiceService,
    private RegisterDataService: RegisterDataService,
    private toastr: NotificationService,
    private datePipe: DatePipe,

  ) {
    this.activateroute.params.subscribe((params: any) => {
      this.paramsid = parseInt(params.id);
    });
  }

  ngOnInit(): void {
    this.initializeValidators();
    this.getminyears();
    forkJoin({
      title: this.lookupdataservice.gettitle(true),
      roleList: this.lookupdataservice.getHCRoleType(true),
      reseller: this.lookupdataservice.getResellerList()
    }).subscribe(
      responses => {
        this.title = responses.title;
        this.filterRoleList = responses.roleList;
        this.roleList = this.filterRoleList.slice();
        this.filterResellerList = responses.reseller;
        this.resellerList = this.filterResellerList.slice();
      })
    if (this.paramsid > 0) {
      this.getFormDetails();
    }


  }

  initializeValidators() {
    this.requestFormGroup = this.fb.group({
      title: [{ value: 1, disabled: true }, Validators.required],
      firstName: [{ value: '', disabled: true }, [Validators.required, Validators.pattern(/\S/)]],
      lastName: [{ value: '', disabled: true }, [Validators.required, Validators.pattern(/\S/)]],
      gender: [{ value: 1, disabled: true }, Validators.required],
      dateOfBirth: [{ value: '', disabled: true }, Validators.required],
      mobileNumberLabel: [{ value: null, disabled: true }],
      mobileNumber: [{ value: '', disabled: true }, Validators.required],
      email: [{ value: '', disabled: true }, [Validators.required, Validators.email]],
      identificationNumber: [{ value: '', disabled: true }, [Validators.required, saIdValidator]],
      roleId: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
      resellerCode: [{ value: null, disabled: true }],
      resellerGroup: [{ value: null, disabled: true }],
      customerCode: [{ value: null, disabled: true }],
      isReachAddOrUpdate: [{ value: null, disabled: true }]
    });
  }
  openDatePicker() {
    this.dateOfBirthPicker.open();
  }
  restrictSpecialChars(event: any) {
    const inputValue = event.target.value;
    const cleanValue = inputValue.replace(/[^a-zA-Z0-9]/g, '');
    event.target.value = cleanValue;
    const controlName = event.target.getAttribute('formControlName');
    this.requestFormGroup.get(controlName)?.setValue(cleanValue, { emitEvent: false });
  }

  onlyNumbers(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const key = event.key;
    if (key.length > 1) {
      return;
    }
    if (input.value.length === 0 && key === '0') {
      event.preventDefault();
    }
    if (!/^[0-9]$/.test(key)) {
      event.preventDefault();
      return;
    }
  }
  onlyNumbersWithZero(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const key = event.key;
    if (key.length > 1) {
      return;
    }
    if (!/^[0-9]$/.test(key)) {
      event.preventDefault();
      return;
    }
  }
  preventLeadingSpace(event: Event) {
    const e = event as KeyboardEvent;
    const input = e.target as HTMLInputElement;

    if (e.key === ' ' && input.selectionStart === 0) {
      e.preventDefault();
    }
  }

  fillcontent() {
    if (this.requestFormGroup.value.identificationNumber.length == 13) {
      const result = validateSaId(this.requestFormGroup.value.identificationNumber);
      if (!result.valid) {
        this.toastr.showError("Enter valid ID number")
        return;
      }
      var Year = this.requestFormGroup.value.identificationNumber.substring(0, 2);
      var Month = this.requestFormGroup.value.identificationNumber.substring(2, 4)
      var Day = this.requestFormGroup.value.identificationNumber.substring(4, 6)
      var cutoff = (new Date()).getFullYear() - 2000

      var datevalue = (Year > cutoff ? '19' : '20') + Year + '/' + Month + '/' + Day
      let dateOfBirth = this.datePipe.transform(datevalue, 'yyyy/MM/dd')

      const dateParts = dateOfBirth.split('/');
      const dateObject = new Date(+dateParts[0], +dateParts[1] - 1, +dateParts[2]);

      this.requestFormGroup.patchValue({
        dateOfBirth: dateObject
      })

      // get the gender
      var genderCode = this.requestFormGroup.value.identificationNumber.substring(6, 10);
      this.requestFormGroup.patchValue({
        gender: (genderCode) < 5000 ? 'female' : 'male'
      })
    }

  }
  getminyears() {
    let nowInMs = new Date().getTime();
    let majorAge = 1000 * 60 * 60 * 24 * 365 * 18;
    let minAge = 1000 * 60 * 60 * 24 * 365 * 150;
    let diffyearMax = new Date(nowInMs - majorAge);
    let diffyearMin = new Date(nowInMs - minAge);
    this.maxDate = (diffyearMax);
    this.minDate = (diffyearMin);
  }

  getFormDetails() {
    this.UserdataService.getUserById(this.paramsid).subscribe((res) => {
      this.userDetails = res;
      if (this.userDetails.reachUserId != null) {
        this.isUserAddedToReach = true;
        this.requestFormGroup.patchValue({
          isReachAddOrUpdate: true
        });
      }
      if (this.userDetails.roleId == 14) {
        this.showResellerCustomer = true;
        this.isReachCheckBoxShow = false;
        this.requestFormGroup.patchValue({
          customerCode: res.refrenceNumber,
          resellerGroup: res.resellerGroup,
          // reachCustomerCode: res.resellerGroup,
        });
      }
      else if (this.userDetails.roleId == 7) {
        // this.isReachCheckBoxShow = false;
        this.isReachCheckBoxShow = true;
        this.showReseller = true;
      }
      else {
        this.showResellerCustomer = false;
      }

      this.requestFormGroup.patchValue({
        ...res,
        mobileNumber: res.mobileNumber.replace("+27", ""),
        gender: res.gender === 1 ? 'male' : 'female',
      });
      // Enable fields for Edit mode
      const fieldsToEnable = [
        'title',
        'firstName',
        'lastName',
        'gender',
        'dateOfBirth',
        'mobileNumber',
        'email',
        'identificationNumber',
        'isReachAddOrUpdate'
      ];

      fieldsToEnable.forEach(field => {
        this.requestFormGroup.get(field)?.enable({ emitEvent: false });
      });

      // Enable reseller fields only for the applicable role
      if (res.roleId == 7) {
        this.requestFormGroup.get('resellerCode')?.enable({ emitEvent: false });
      } else if (res.roleId == 14) {
        this.requestFormGroup.get('resellerGroup')?.enable({ emitEvent: false });
        this.requestFormGroup.get('customerCode')?.enable({ emitEvent: false });
      }
    });
  }

  onRoleChange(event: MatSelectChange) {
    const roleId = event.value;

    const fieldsToToggle = [
      'title',
      'firstName',
      'lastName',
      'gender',
      'dateOfBirth',
      'mobileNumber',
      'email',
      'identificationNumber',
      'resellerCode',
      'resellerGroup',
      'customerCode',
      'isReachAddOrUpdate'
    ];

    fieldsToToggle.forEach(field => {
      const control = this.requestFormGroup.get(field);

      if (roleId !== null && roleId !== undefined && roleId !== '') {
        control?.enable({ emitEvent: false });
      } else {
        control?.disable({ emitEvent: false });
      }
    });
    if (event.value == 7 || event.value == 14) {
      this.showCompanyRegistrationNumber = true;
    }
    else {
      this.showCompanyRegistrationNumber = false;
    }
    if (event.value == 7) {
      this.showReseller = true;
      // this.isReachCheckBoxShow = false;
      this.isReachCheckBoxShow = true;
      this.clearValidators('resellerCode', false);
    } else {
      this.showReseller = false;
      this.isReachCheckBoxShow = true;
      this.clearValidators('resellerCode', true);
    }

    if (event.value == 14) {
      this.showResellerCustomer = true;
      this.isReachCheckBoxShow = false;
      this.clearValidators('resellerGroup', false);
      this.clearValidators('customerCode', false);

    }
    else {
      this.showResellerCustomer = false;
      this.isReachCheckBoxShow = true;
      this.clearValidators('resellerGroup', true);
      this.clearValidators('customerCode', true);
    }

    this.setNull("resellerCode");
    this.setNull("resellerGroup");
    this.setNull("customerCode");
    // if (event.value == 7 || event.value == 14) {
    if (event.value == 14) {
      this.isReachCheckBoxShow = false;
    }
    else {
      this.isReachCheckBoxShow = true;
    }
  }

  clearValidators(controllername, isClear) {
    if (isClear) {
      this.requestFormGroup.controls[controllername].clearValidators();
    } else {
      this.requestFormGroup.controls[controllername].setValidators(Validators.required);
    }
    this.requestFormGroup.controls[controllername].updateValueAndValidity();
  }

  setNull(controllername) {
    this.requestFormGroup.controls[controllername].setValue(null);
  }

  goToHomeConnectUser() {
    this.navigate.goToHomeConnectUser();
  }


  onsubmit() {
    if (this.requestFormGroup.valid) {
      let payload = {
        ...this.userDetails,
        ...this.requestFormGroup.value,
        gender: this.requestFormGroup.value.gender === 'male' ? 1 : 2,
        userId: this.paramsid
      }
      this.RegisterDataService.registerHCUser(payload).subscribe({
        next: (res) => {

          const message = res;
          if (message === "Email Already Exists in Prepaid Portal." ||
            message === "Identification Number Already Exists in Prepaid Portal.") {

            let txt = '';

            if (this.paramsid === 0) {
              txt = 'This user already exists in Prepaid Portal. Do you want to add this user to Home-Connect?';

              const Yes = 'Yes';
              const No = 'No';

              Swal.fire({
                text: txt,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#7D32DE',
                cancelButtonColor: '#23C00A',
                confirmButtonText: Yes,
                cancelButtonText: No,
              }).then((result) => {
                if (result.value) {
                  this.requestFormGroup.patchValue({
                    isReachAddOrUpdate: false
                  }); this.onsubmit();
                }
              });
            }
            else {
              this.toastr.showError(res);
            }
          }
          else if (this.paramsid === 0) {
            this.toastr.showSuccess("Login Created Successfully");
            this.goToHomeConnectUser();
          } else if (this.paramsid > 0) {
            this.toastr.showSuccess("Login Updated Successfully");
            this.goToHomeConnectUser();
          }


        },

      });

    }
    else {
      this.requestFormGroup.markAllAsTouched();
      this.toastr.showError("Please fill in all mandatory fields!")
    }
  }


  CheckboxReach(event: MatCheckboxChange) {
    this.requestFormGroup.get('isReachAddOrUpdate')?.setValue(event.checked);
    this.isReachChecked = event.checked

  }


}
